export default "__VITE_ASSET__9277455f__"